var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.023 0 0 4.023 0 9C0 13.977 4.023 18 9 18C13.977 18 18 13.977 18 9C18 4.023 13.977 0 9 0ZM12.87 12.87C12.519 13.221 11.952 13.221 11.601 12.87L9 10.269L6.399 12.87C6.048 13.221 5.481 13.221 5.13 12.87C4.779 12.519 4.779 11.952 5.13 11.601L7.731 9L5.13 6.399C4.779 6.048 4.779 5.481 5.13 5.13C5.481 4.779 6.048 4.779 6.399 5.13L9 7.731L11.601 5.13C11.952 4.779 12.519 4.779 12.87 5.13C13.221 5.481 13.221 6.048 12.87 6.399L10.269 9L12.87 11.601C13.212 11.943 13.212 12.519 12.87 12.87Z",
    fill: "#BB3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBrown);
export default __webpack_public_path__ + "static/media/crossBrown.10bbf6c77aac5143a0ae5d0548d7ed36.svg";
export { ForwardRef as ReactComponent };